import { render, staticRenderFns } from "./server-detach-volume.vue?vue&type=template&id=4a181142&scoped=true&"
import script from "./server-detach-volume.vue?vue&type=script&lang=js&"
export * from "./server-detach-volume.vue?vue&type=script&lang=js&"
import style0 from "./server-detach-volume.vue?vue&type=style&index=0&id=4a181142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a181142",
  null
  
)

export default component.exports